module.exports = __webpack_public_path__ + "img/20_dice[6].7c68c105.png";